import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';

import {awsConfig} from '../../shared/config';
import store from '../../redux/store'


// export const getCurrentCognitoUser = () => {
//     var poolData = { 
//         UserPoolId : awsConfig.cognito.userPoolId,
//         ClientId : awsConfig.cognito.userPoolClientId
//     };
//     var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
//     var cognitoUser = userPool.getCurrentUser();

//     return cognitoUser;
// }


export const getNewCognitoUser = (username) => {
    var poolData = { 
        UserPoolId : awsConfig.cognito.userPoolId,
        ClientId : awsConfig.cognito.userPoolClientId
    };
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    var userData = {
        Username : username,
        Pool : userPool
    };

    var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

    return cognitoUser;
}


export const isCachedUserSessionActive = () => {
    const state = store.getState();
    const cognitoUser = state.auth.cognitoUser;

    return isCognitoUserSessionActive(cognitoUser);
}


export const isCognitoUserSessionActive = (cognitoUser) => {
    var isActive = false;

    if(cognitoUser !=null) {
        try{
            cognitoUser.getSession(function(err, session) {
                    if (err) {
                        console.log(">> Error getting the session: " + err);
                    }
                    else{
                        isActive = session.isValid();
                    }
                }
            )
        }
        catch(error) {
            console.log("Session Error: " + error);
        }
    }
    else {
        console.log(">> No CognitoUser");
    }    

    return isActive;
}


export const getJwtToken = (stateAuth) => {
    var jwtToken = null;

    const state = store.getState();
    const cognitoUser = state.auth.cognitoUser;

    if(cognitoUser !=null) {
        cognitoUser.getSession(function(err, session) {
                if (err) {
                    console.log(">> Error getting the session: " + err);
                }
                else{
                    if( session.isValid() ) {
                        jwtToken = session.getIdToken().getJwtToken();
                    }
                }
            }
        )
    }
    else {
        console.log(">> No CognitoUser");
    }    

    return jwtToken;
}


export function resetPassword(username) {
    var cognitoUser = getNewCognitoUser(username);

    // call forgotPassword on cognitoUser
    // cognitoUser.forgotPassword({
    //     onSuccess: function(result) {
    //         console.log('call result: ' + result);
    //     },
    //     onFailure: function(err) {
    //         console.log('call err: ' + err);
    //     },
    //     // inputVerificationCode() { // this is optional, and likely won't be implemented as in AWS's example (i.e, prompt to get info)
    //     //     var verificationCode = prompt('Please input verification code ', '');
    //     //     var newPassword = prompt('Enter new password ', '');
    //     //     cognitoUser.confirmPassword(verificationCode, newPassword, this);
    //     // }
    // });

    return new Promise((resolve, reject) => {
        cognitoUser.forgotPassword({
            onSuccess(data) {
                // Data would be -> "CodeDeliveryDetails":{"AttributeName":"email","DeliveryMedium":"EMAIL","Destination":"f***@b***"}}
                resolve(data);
            },
            onFailure(err) {
                reject(err);
            }
        });
    });
}

// confirmPassword can be separately built out as follows...  
export function confirmPassword(username, verificationCode, newPassword) {
    var cognitoUser = getNewCognitoUser(username);

    return new Promise((resolve, reject) => {
        cognitoUser.confirmPassword(verificationCode, newPassword, {
            onSuccess() {
                resolve();
            },
            onFailure(err) {
                reject(err);
            },
        });
    });
}

export function changePassword(oldPassword, newPassword) {

    var poolData = { 
        UserPoolId : awsConfig.cognito.userPoolId,
        ClientId : awsConfig.cognito.userPoolClientId
    };
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();
        if (cognitoUser != null) {
            console.log(">> We have a user");

            cognitoUser.getSession(function (err, session) {
                if (err) {
                    reject(err);
                }
                else {
                    console.log('>> session validity: ' + session.isValid());
                    cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
                        if (err) {
                            reject(err);
                        }
                        else {
                            resolve(result);
                        }
                    });
                }
            });
        }
        else {
            console.log(">> No user");
            var error = new Error('Error obtaining current user');
            error.code = 'NO_CURRENT_USER';
            reject(error);
        }
    });

    // return new Promise((resolve, reject) => {
    //     cognitoUser.changePassword(oldPassword, newPassword, function(err, result) {
    //         if (err) {
    //             reject(err);
    //         }
    //         else{
    //             resolve(result);
    //         }
    //     });
    // });
}


export const signOut = () => {
    console.log(">> signOut");

    const state = store.getState();
    const cognitoUser = state.auth.cognitoUser;

    if(cognitoUser !=null) {
        cognitoUser.signOut();
    }
}